import { sendRequestProtocols } from "../axios";

export default {
  state: {
    protocols_list: [],
    protocol_info: null,
    winner_info: {}
  },
  mutations: {
    setProtocolList(state, payload) {
      state.protocols_list = payload;
    },
    setProtocolInfo(state, payload) {
      state.protocol_info = payload;
    },
    clearProtocolInfo(state) {
      state.protocol_info = null;
    },
    setWinnerInfo(state, payload) {
      state.winner_info = payload;
    }
  },
  actions: {
    async getProtocolInfoByWinId({ commit }, obj) {
      const { data } = await sendRequestProtocols(
        `getProtocolByWinId/${obj}`,
        "get"
      );
      return data;
    },
    async CLEAR_PROTOCOL_INFO({ commit }) {
      commit("clearProtocolInfo");
    },
    async PROTOCOLS_COUNT({ commit }) {
      const { data } = await sendRequestProtocols(
        `protocolscount`,
        "get"
      );
      return data;
    },
    async GET_PROTOCOLS_LIST({ commit }) {
      const { data } = await sendRequestProtocols(
        `protocolslist`,
        "get"
      );
      commit("setProtocolList", data);
      return data;
    },
    async PROTOCOL_INFO_BY_NUMBER({ commit }, payload) {
      commit("SET_PROCESSING", true);
      const setDefault = (payload)=>{
        const NAObj = {
          calc_send: false,
          contractTerm: null,
          createdAt: null,
          egrul: null,
          endDate: null,
          fz: null,
          guaranteeing: null,
          last_update: null,
          link: null,
          lotNumber: "N/A",
          name: null,
          not_required: null,
          notificationNumber: payload.purchase_number,
          placer_name: null,
          price: null,
          protocolDate: null,
          protokol_date: null,
          publishDate: null,
          purchase: null,
          statinfo: null,
          winner_inn: payload.winner_inn ? payload.winner_inn : null,
          winner_kpp: null,
          winner_name: payload.winner_name ? payload.winner_name : null,
          winner_send: false
        };
        commit("setProtocolInfo", NAObj);
        return NAObj;
      }
      try {
        const obj = { number: payload.purchase_number, lot: payload.lot };
        const { data } = await sendRequestProtocols(
          `protocolInfoByNumber/${payload.purchase_number}`,
          "get",
          obj
        );
        const reg = /Not find notification/g;
        if (reg.test(data.message)) {
          return {...setDefault(payload),message: 'notFind'}
        }else{
          if (Array.isArray(data)) {
            commit("setProtocolInfo", data[0]);
            return data[0];
          }
          commit("setProtocolInfo", data);
          return data;
        }
      } catch (e) {
        return {...setDefault(payload),message: 'notFind'}
      }finally{
        commit("SET_PROCESSING", false);
      }
    }
  },
  getters: {
    // getRegionRe: (state) =>state.regions_re,
    protocols_list: state => state.protocols_list,
    protocol_info: state => state.protocol_info,
    winner_info: state => state.winner_info
  }
};
